export const environment = {
  production: true,
  buildId: '3285219670221151',
  configFile: 'config.json',
};
